import { css } from "goober";

export const WidgetContainer = () => css`
  max-width: var(--sp-container);
  width: 100%;
  padding-block-end: var(--sp-4);

  .widget {
    --radii: var(--br-lg);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: var(--sp-13);
    width: 100%;
    padding-inline: var(--sp-4);
    background: linear-gradient(
      to bottom,
      hsla(var(--shade1-hsl) / 10%),
      hsla(var(--shade1-hsl) / 5%)
    );
    border-radius: var(--radii);
    box-shadow: var(--highlight);
    backdrop-filter: blur(10px);
    cursor: pointer;
    overflow: hidden;

    &:hover {
      background: linear-gradient(
        to bottom,
        hsla(var(--shade1-hsl) / 15%),
        hsla(var(--shade1-hsl) / 10%)
      );
    }
  }

  .side {
    display: flex;
    align-items: center;
    gap: var(--sp-3);
  }

  .avatar {
    position: relative;

    img {
      border-radius: 50%;
    }
    svg {
      position: absolute;
      bottom: 0;
      right: -0.25rem;
      width: var(--sp-3);
      height: var(--sp-3);
      background: var(--game-color);
      box-shadow: 0 0 0 2px var(--shade9);
      border-radius: var(--br-sm);
    }
    path {
      fill: var(--shade9);
    }
  }

  .text-items,
  .text-item {
    display: flex;
    align-items: center;
    gap: var(--sp-2);
    color: var(--shade0-50);
  }
  .text-item {
    &:not(:last-child)::after {
      content: "";
      width: 2px;
      height: 2px;
      background: var(--shade0-25);
      border-radius: 2px;
    }
  }
  .cta {
    color: var(--cta-color);
  }
  .accept-action {
    display: flex;
    align-items: center;
    height: var(--sp-6);
    padding-inline: var(--sp-1_5);
    color: var(--shade1);
    background: var(--shade2-15);
    box-shadow: var(--hightlight);
    border-radius: var(--br);
  }
  .countdown-bar {
    position: absolute;
    bottom: 0;
    left: var(--offset, 0);
    width: 100%;
    height: var(--sp-1);
    background: var(--cta-color);
    overflow: hidden;
    transition: left 1s linear;
  }
`;
